<template>
  <div class="">
    <info-bulle
      :libelle="labelLibelle"
      :name="name"
      :is-libelle-input="true"
    >
      <template #libelleBefore>
        <p
          :for="name"
          v-html="textLibelle"
          class="text-sm text-gray-600 truncate mb-2"
          :style="(inherits != undefined && inherits != null && inherits) ? 'color: inherit; font-size: inherit; font-weight: inherit;' : ''"
          @mouseover="tooltipLibelle=true;"
          @mouseleave="tooltipLibelle=false;"
        />
        <div
          class="self-center ml-auto mr-4 text-pink-600 cursor-pointer"
          @click.prevent="toggleManualInput()"
        >
          <icon
            :name="manualInput ? 'calendar' : 'edit'"
          />
        </div>
      </template>
      <template #tooltipLibelleBefore>
        <!-- Display libelle when hover -->
        <transition
          enter-active-class="duration-300 delay-1000"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="tooltipLibelle && libelle != null && libelle != ''"
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ libelle }}
          </div>
        </transition>
      </template>
    </info-bulle>
    <div
      class="relative"
      @mouseover="tooltipValue=true;"
      @mouseleave="tooltipValue=false;"
    >
      <input
        ref="manualInputEl"
        type="text"
        :class="{
          'appearance-none border border-indigo-600 rounded-md placeholder-gray-600 text-gray-900 pl-3 pr-7 py-2 xxl:pl-4 xxl:pr-8 xxl:py-3 2xl:pl-5 2xl:pr-9 2xl:py-4 block w-full cursor-default focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 transition duration-150 ease-in-out text-sm sm:leading-5 truncate datepicker-input': true,
          'hidden': !manualInput
        } "
        v-model="manualInputFormatted"
        @input="handleInput"
        @blur="finishManualInput"
        @keyup.enter="finishManualInput"
        placeholder="jj/mm/aaaa"
      >
      <vuejs-datepicker
        :language="fr"
        :input-class="{
          'appearance-none border border-indigo-600 rounded-md placeholder-gray-600 text-gray-900 pl-3 pr-7 py-2 xxl:pl-4 xxl:pr-8 xxl:py-3 2xl:pl-5 2xl:pr-9 2xl:py-4 block w-full cursor-default focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 appearance-none transition duration-150 ease-in-out text-sm sm:leading-5 truncate datepicker-input': true,
          'bg-gray-200 cursor-not-allowed': (disabled || disabled_pass),
          'bg-white cursor-pointer': !(disabled || disabled_pass),
          'hidden': manualInput
        }"

        :calendar-class="{
          'hidden': manualInput,
          'datepicker-form text-sm md:right-0': direction == 'left',
          'datepicker-form text-sm md:left-0': direction == undefined || direction == null || direction == 'right'
        }"
        :full-month-name="true"
        :monday-first="true"
        :format="format"
        :minimum-view="minView"
        :open-date="openDate"
        :initial-view="initialview"
        :disabled-dates="disabledDates"
        v-model="mutableValue"
        :inline="Boolean(inline)"
        :disabled="disabled || disabled_pass"
        ref="calendar"
      >
        <div
          v-if="!inline && !manualInput && !(disabled || disabled_pass)"
          slot="afterDateInput"
          class="pointer-events-none absolute inset-y-0 right-2 flex items-center text-pink-600 px-2"
        >
          <icon name="calendar" />
        </div>
        <div
          slot="beforeCalendarHeader"
          class="datepicker-header"
        >
          <div v-if="libelle_header">
            {{ libelle_header }}
          </div>
          <div v-else>
            Sélectionner une date
          </div>
          <hr>
          <div
            class="cursor-pointer"
            style="font-size:13px;"
            @click="mutableValue = ''"
          >
            Effacer date
          </div>
        </div>
      </vuejs-datepicker>

      <!-- Display value when hover -->
      <transition
        enter-active-class="duration-300 delay-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-300"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="tooltipValue && mutableValue != null && mutableValue != ''"
          class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
        >
          {{ new Date(mutableValue).toLocaleDateString(undefined, options) }}
        </div>
      </transition>
    </div>

    <!-- A hidden input to stock attributes necessary and name (to calculate progress) -->
    <input
      type="hidden"
      :necessary="necessaryDate"
      :value="mutableValue"
      :name="name"
    >
    <div
      v-if="error || inputErr"
      class="text-pink-600 text-sm"
    >
      {{ msgError }} {{ inputErr }}
    </div>
  </div>
</template>

<script>
import vuejsDatepicker from 'vuejs-datepicker';
import {fr} from 'vuejs-datepicker/dist/locale';
import Icon from '../../components/Icon';
import InfoBulle from '../../components/InfoBulle';

export default {
  data: function () {
    return {
      fr: fr,
      mutableValue: this.value,
      disabled_pass: false,
      tooltipLabel: false,
      tooltipValue: false,
      tooltipLibelle: false,
      textLibelle: '&nbsp;',
      options: '',
      input: null,
      inputErr: null,
      manualInput: false,
      manualInputFormatted: '',
      finishManualInputJustFired: false
    };
  },
  components: {
    vuejsDatepicker,
    InfoBulle,
    Icon,
  },

  props: ['name', 'libelle', 'value', 'format', 'necessary', 'minView', 'openDate', 'initialview', 'disabledDates', 'libelle_header', 'inline', 'disabled', 'error',
    'msgError', 'labelLibelle', 'direction', 'inherits', 'necessaryDate'],


  mounted() {
    // Manage edit permission for neopass pages
    if (this.$route.path.includes('form/neopass')) {
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if (this.$can(page + '_edit', idpass)) {
        this.disabled_pass = false;
      } else {
        this.disabled_pass = true;
      }
    } else {
      this.disabled_pass = false;
    }

    //assign text to textLibelle if prop Libelle is filled
    if (this.libelle != undefined && this.libelle != null) {
      this.textLibelle = this.libelle;
    }
  },
  methods: {
    handleInput() {
      // Remove non-numeric characters
      let sanitizedInput = this.manualInputFormatted.replace(/[^0-9/]/g, '');

      // Format date as dd/mm/yyyy
      let formattedDate = '';
      for (let i = 0; i < sanitizedInput.length; i++) {
        if (
          (i === 2 || i === 5) &&
          sanitizedInput[i] !== '/' &&
          sanitizedInput[i - 1] !== '/'
        ) {
          formattedDate += '/';
        }
        formattedDate += sanitizedInput[i];
      }

      this.manualInputFormatted = formattedDate;
    },

    finishManualInput() {
      if (this.finishManualInputJustFired) {
        return;
      }
      this.clearInputError();

      this.finishManualInputJustFired = true;
      setTimeout(() => this.finishManualInputJustFired = false, 500);

      const dateArray = this.manualInputFormatted.split('/');

      if (parseInt(dateArray[1], 10) - 1 > 12) {
        this.inputErr = 'Date Invalide';
        return;
      }

      if (parseInt(dateArray[0], 10) > 31) {
        this.inputErr = 'Date Invalide';
        return;
      }

      let parsedDate = new Date(
        parseInt(dateArray[2], 10), // Year
        parseInt(dateArray[1], 10) - 1, // Month (zero-based)
        parseInt(dateArray[0], 10) // Day
      );

      if (isNaN(parsedDate.getTime())) {
        this.inputErr = 'Date Invalide';
        return;
      }

      this.manualInput = false;
      this.mutableValue = parsedDate;
    },

    toggleManualInput() {
      this.manualInput = !this.manualInput;
      if (this.manualInput) {
        console.log(this.$refs.manualInputEl);
        setTimeout(() => this.$refs.manualInputEl.focus(), 1);
      }
    },

    clearInputError() {
      this.inputErr = null;
    },

    displayLabelTooltip(e) {
      if (e.x < (2 * window.outerWidth / 3)) {
        document.querySelectorAll('.tooltip-label[name=\'' + this.name + '\']')[0].classList.remove('right-0');
      }

      this.tooltipLabel = !this.tooltipLabel;
    },
    forceHideTooltipLabel(e) {
      if (e.target.classList.contains('tooltip-label') && e.target.name == this.name) {
        this.tooltipLabel = !this.tooltipLabel;
      } else {
        if (this.tooltipLabel)
          this.tooltipLabel = false;
      }
    },
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);
      this.$emit('loseFocus');
    },
    value() {
      this.mutableValue = this.value;
    },
  },
  directives: {
    clickOutside: {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
};
</script>
